import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(email, password);
      toast.success(`Benvenuto, ${u.name}`);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col lg:flex-row">
      <div className="brand-gradient relative flex flex-col justify-between overflow-hidden px-8 py-10 text-white lg:w-[46%] lg:px-14 lg:py-14">
        <img src="/brand/logo-white-box.png" alt="DR Multiservice" className="h-16 w-auto self-start rounded-xl lg:h-20" />
        <div className="mt-10 lg:mt-0">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-white/80">DR APP</p>
          <h1 className="mt-3 text-4xl font-extrabold leading-tight sm:text-5xl">Direzione e controllo operativo</h1>
          <p className="mt-4 max-w-md text-base text-white/85">Commesse, ordini di lavoro, scadenze e responsabilità in un unico sistema interno, con Toth come assistente operativo.</p>
        </div>
        <p className="mt-10 text-xs text-white/70">Uso esclusivamente interno · D.R. Multiservice srl</p>
      </div>
      <div className="flex flex-1 items-center justify-center px-6 py-12">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <div className="icon-chip mb-6 h-12 w-12"><Lock className="h-5 w-5" /></div>
          <h2 className="text-2xl font-extrabold">Accedi</h2>
          <p className="mt-1 text-sm text-muted-foreground">Gli account sono creati dall'amministratore.</p>
          <div className="mt-8 space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email aziendale</Label>
              <Input id="email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="h-12 rounded-xl bg-white" data-testid="login-email-input" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="h-12 rounded-xl bg-white" data-testid="login-password-input" />
            </div>
            {error && <p className="rounded-xl bg-red-50 px-3 py-2 text-sm font-medium text-red-700" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={busy} className="h-12 w-full rounded-xl text-base font-bold" data-testid="login-submit-button">
              {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Entra"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
